export const bypassApps = [
  'account-grouping',
  'account-linking',
  'account-review',
  'aml-monitor',
  'automated-reports',
  'book-management',
  'carrier-policy-details',
  'carrier-portal',
  'case-explorer',
  'case-management',
  'post-trade',
  'profile-history',
  'rep-review',
  'settings',
  'tools',
  'trade-review',
  'rb-chatbot',
];

export const inactiveUsersApps = [
  'account-grouping',
  'account-linking',
  'account-review',
  'aml-monitor',
  'rep-review',
  'trade-review',
];
